<template>
  <main class="content aui-content">
    <Header />
    <div class="content_body">
      <router-view />
    </div>
    <Footer />
  </main>
</template>

<script>
import Footer from '../footer.vue'
import Header from './header.vue'

export default {
  components: {
    Footer,
    Header
  }
}
</script>
